import {isEmpty} from "@util/index";
import { sessionKey } from '@src/config'

/**
 * 业务 session 存储容器工具
 */
export default class Store {

	static storage = sessionStorage;

	static get(key: string): any {
		const sk = this.storage.getItem(sessionKey);
		if (isEmpty(sk) || !sk) {
			return undefined;
		}
		const SKObject = JSON.parse(sk);
		return SKObject[key];
	}

	static getAll() {
		const sk = this.storage.getItem(sessionKey);
		if (isEmpty(sk) || !sk) {
			return undefined;
		}
		return JSON.parse(sk);
	}

	static set(key: string, val?: any) {
		let sk = this.storage.getItem(sessionKey);
		if (isEmpty(sk) || !sk) {
			sk = "{}"
		}
		const SKObject = JSON.parse(sk);
		if (isEmpty(val)) {
			delete SKObject[key];
		} else {
			SKObject[key] = val;
		}
		sk = JSON.stringify(SKObject)
		this.storage.setItem(sessionKey, sk);
	}

	static clearAll() {
		const all = this.getAll();
		if (!all) {
			return
		}
		const deleteKeys = [];
		for (const k in all) {
			if (k.indexOf('sys_') === 0) {
				continue
			} else {
				deleteKeys.push(k);
			}
		}
		for (const k of deleteKeys) {
			delete all[k];
		}

		const sk = JSON.stringify(all)
		this.storage.setItem(sessionKey, sk);
	}

	static clearKey(key: string) {
		const all = this.getAll();
		for (const k in all) {
			if (k === key) {
				delete all[k];
			}
		}
		const sk = JSON.stringify(all)
		this.storage.setItem(sessionKey, sk);
	}


	static setUser(user?: any) {
		this.set("userInfo", user)
	}

	static getUser(): any {
		return this.get("userInfo") || {};
	}

	static removeUser(): any {
		return this.remove("userInfo");
	}

	static getObj<T>(key: string) {
		try {
			return JSON.parse(this.storage.getItem(key) || '') as T
		} catch (err) {
			return undefined
		}
	}

	static setObj(key: string, value: any) {
		this.storage.setItem(key, JSON.stringify(value))
	}

	static remove(key: string) {
		this.set(key)
	}
}
